import { getFeedback } from '@sentry/nextjs';

const FeedbackService = {
    open: async (options?: {
        formTitle?: string;
        messagePlaceholder?: string;
        submitButtonLabel?: string;
        successMessageText?: string;
    }) => {
        const {
            formTitle = 'Feedback',
            messagePlaceholder = 'What would you like to share?',
            submitButtonLabel = 'Submit',
            successMessageText = 'Thank you for your feedback!',
        } = options ?? {};

        const feedback = getFeedback();
        const form = await feedback?.createForm({
            formTitle,
            messagePlaceholder,
            successMessageText,
            submitButtonLabel,
        });

        if (form) {
            form.appendToDom();
            form.open();
        } else {
            alert('Feedback module blocked by browser. Please send us an email at support@directenergypartners.com');
        }
    },
};

export { FeedbackService };
